import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=7b33e432&scoped=true"
import script from "./distribution.vue?vue&type=script&lang=js"
export * from "./distribution.vue?vue&type=script&lang=js"
import style0 from "./distribution.vue?vue&type=style&index=0&id=7b33e432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b33e432",
  null
  
)

export default component.exports